import styled from "@emotion/styled";

export const Root = styled.form`
  padding: 0 20px;
  margin-bottom: 2%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  & .card-filter {
    & .theme-card-body {
      display: grid;
      gap: 24px;
    }
  }
`;

export const FlexButton = styled.div<{ $justifyContent?: string }>`
  display: flex;
  gap: 24px;
  justify-content: ${(props) => props.$justifyContent || "space-between"};
  & button {
    width: 92px;
  }
`;

export const Title = styled.p`
  font-size: 24px;
  font-weight: 500;
  color: #000000;
`;

export const StepTitle = styled.p`
  font-weight: 500;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: -0.2px;
`;

export const StepDescription = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: -0.2px;
  white-space: break-spaces;
`;

export const Step1Content = styled.div`
  display: grid;
  gap: 8px;
  & .table-template {
    margin-bottom: 16px;
  }
`;

export const Step1Title = styled.p`
  font-weight: 700;
  font-size: 16px;
  line-height: 140%;
  letter-spacing: -0.2px;
  color: #253858;
`;

export const TextBoolean = styled.p<{ $text?: string }>`
  font-weight: 500;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: -0.2px;
  color: ${({ $text }) =>
    $text === "N/A" ? "#395278" : $text === "Yes" ? "#42AD47" : "#EB4553"};
`;

export const Flex = styled.div`
  display: flex;
  gap: 24px;
`;

export const FlexDownload = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  font-weight: 500;
  font-size: 16px;
  line-height: 140%;
  letter-spacing: -0.2px;
  color: #3548C9;
`;
